module.exports = __webpack_public_path__ + "site/img/173.e37b800a.jpg";